export default __webpack_public_path__ + "static/media/icon_receive_money_dollar.3f53b37e.svg";